import * as Yup from 'yup'
import { pt } from 'yup-locale-pt';

Yup.setLocale(pt);
export default Yup.object().shape({
  login: Yup.string().email().required().label('E-mail'),
  password: Yup.string().required().label('Senha')
})